import { FC } from 'react'
import styled, { css } from 'styled-components'
//states
import { useRecoilValue } from 'recoil'
import { isInViewFooterState, stepState } from '../../states/messageState'
//components
import { useParams } from 'react-router-dom'
import { ChooseChangeAddress } from './steps/ChooseChangeAddress'
import { ChooseChangeEmail } from './steps/ChooseChangeEmail'
import { ChooseNaturalFailure } from './steps/ChooseNaturalFailure'
import { ChooseProduct } from './steps/ChooseProduct'
import { InputDate } from './steps/InputDate'
import { InputOverView } from './steps/InputOverView'
import { InputShippingAddress } from './steps/InputShippingAddress'
import { InputUpdateEmail } from './steps/InputUpdateEmail'
import { InputUpdatePhone } from './steps/InputUpdatePhone'
import { InputVerifyCode } from './steps/InputVerifyCode'
import { InquiryCodeOrEmail } from './steps/InquiryCodeOrEmail'
import { NotFoundInquiryCodeOrEmail } from './steps/NotFoundInquiryCodeOrEmail'
import { Start } from './steps/Start'
import { UploadImage } from './steps/UploadImage'

export const Footer: FC = () => {
  const { id } = useParams<{ id: string }>()
  let currentStep = useRecoilValue(stepState)
  const isInView = useRecoilValue(isInViewFooterState)

  if (id) {
    if (currentStep === 'initial') {
      currentStep = 'inputInquiryCodeOrEmail'
    } else if (currentStep == 'notFoundInquiryCodeOrEmail') {
      return <></>
    }
  }

  const renderStep = () => {
    switch (currentStep) {
      case 'initial':
        return <Start />
      case 'inputInquiryCodeOrEmail':
        return <InquiryCodeOrEmail id={id} />
      case 'inputVerifyCode':
        return <InputVerifyCode />
      case 'notFoundInquiryCodeOrEmail':
      case 'beforePlanStart':
        return <NotFoundInquiryCodeOrEmail />
      case 'chooseProduct':
        return <ChooseProduct />
      case 'inputOverView':
        return <InputOverView />
      case 'inputDate':
        return <InputDate />
      case 'chooseNaturalFailure':
        return <ChooseNaturalFailure />
      case 'chooseChangeEmail':
        return <ChooseChangeEmail />
      case 'inputUpdateEmail':
        return <InputUpdateEmail />
      case 'inputUpdatePhone':
        return <InputUpdatePhone />
      case 'chooseChangeAddress':
        return <ChooseChangeAddress />
      case 'inputShippingAddress':
        return <InputShippingAddress />
      case 'uploadImage':
        return <UploadImage />
    }
  }

  return <StyledSelectSection inView={isInView}>{renderStep()}</StyledSelectSection>
}

const StyledSelectSection = styled.section<{ inView: boolean }>`
  display: flex;
  justify-content: center;
  height: auto;
  max-width: 1024px;
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
  margin-left: auto;
  margin-right: auto;
  transition: 0.5s;
  ${({ inView }) =>
    inView
      ? css`
          transform: translateY(0);
        `
      : css`
          transform: translateY(200px);
        `};
`
